import styled from 'styled-components';
import { minMediaQueries, maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
import { grid } from '@finect/tabular-utils/grid';

/* stylelint-disable */

export const HighlightsCompanies = styled.div`
  min-height: 160px;

  ${minMediaQueries.miniDesktop`
    min-height: 240px;
  `};
`;

export const HighlightsCompaniesContent = styled.div`
  max-width: ${grid(12)}px;
  padding: 0 12px;
  margin: 32px auto;
  align-items: center;
  display: flex;
  flex-wrap: wrap;

  ${minMediaQueries.phone`
    display: flex;
    flex-wrap: wrap;
    margin: 40px auto 24px;
    justify-content: center;
    padding: 0 48px;
  `}

  ${minMediaQueries.phablet`
    display: flex;
    flex-wrap: wrap;
    margin: 40px auto 24px;
    justify-content: center;
    padding: 0 48px;
  `}

  ${minMediaQueries.miniDesktop`
    margin: 64px auto 0;
  `};
`;

export const LogoContent = styled.div`
  display: flex;
  max-width: ${({ qty }) => 100 / (qty > 0 ? qty : 5)}%;
  min-width: ${({ qty }) => 100 / (qty > 0 ? qty : 5)}%;

  a,
  span {
    margin: 0 auto;
  }

  a > img,
  span > img {
    width: 100%;
  }

  &:not(:first-child) {
    margin-top: 8px;
  }

  ${maxMediaQueries.miniDesktop`
    max-width: 25%;

    &:not(:first-child) {
      margin-top: 0;
    }
  `}

  ${maxMediaQueries.phablet`
    max-width: 33%;
    margin: auto;
  `}
`;
